function getServiceUrl(cloudId, baseUrlOverride) {
  const path = `/gateway/api/watermelon/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
  if (baseUrlOverride) {
    return `${baseUrlOverride}${path}`;
  }
  return path;
}
export async function isGlobalExperienceWorkspaceForCloudId(cloudId, baseUrlOverride) {
  try {
    const response = await fetch(getServiceUrl(cloudId, baseUrlOverride), {
      credentials: 'include'
    });
    if (response.ok) {
      const workspaceType = await response.text();
      return workspaceType === 'GLOBAL_EXPERIENCE';
    }
    return false;
  } catch (err) {
    return false;
  }
}